import Typography from '@mui/material/Typography';
import TextEllipsis from '../../../../../text/TextEllipsis';
import TextStatusUnitOfLearning from '../../../../../text/TextStatus';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const RenderCurriculum = ({ elements, structure = {}, lcs, width }) => {
  const newData = {};
  structure?.children?.map((item) => {
    newData[item._id] = {};
    newData[item._id].elements = {};

    newData[item._id].lcs = lcs.map((lc) => {
      const lcData = lc.curriculumElements[structure._id] || {};
      const lcDataElements = elements[lc.lcId];

      if (lcDataElements) {
        const elementsData = lcDataElements.children.find(
          (item) => String(item._id) === String(lcData?.value)
        );
        if (elementsData) {
          const se = elementsData.elements.find((el) => el.elementStructureId === item._id);
          if (se) {
            newData[item._id].elements[lc.lcId] = se;
          }
        }
      }
      return {
        ...lc,
        curriculumElements: {
          [item._id]: lcData?.children ? lcData.children[item._id] : {}
        }
      };
    });
    newData[item._id].structure = item;
  });

  return (
    <>
      {Object.keys(newData)
        .reverse()
        .filter((key) =>
          newData[key].lcs.some((lc) => lc.curriculumElements[newData[key].structure._id]?.value)
        )
        .map((key) => {
          return (
            <RenderCurriculum
              key={key}
              elements={newData[key].elements}
              structure={newData[key].structure}
              lcs={newData[key].lcs}
              width={width}
            />
          );
        })}
      <TableRow className='w-full gap-1' key={structure?._id}>
        <TableCell
          align='center'
          backgroundColor={structure?.primaryColor}
          color={structure?.secondaryColor}
          className={['font-bold sticky left-0px z-10', width].join(' ')}
          children={structure?.name}
          style={{
            backgroundColor: structure?.primaryColor,
            color: structure?.secondaryColor,
            width: 400
          }}
        />
        {lcs.map((lc, index) => {
          const lcData = lc.curriculumElements[structure?._id] || {};
          const lcDataElements = elements[lc?.lcId] || {};
          let elementsData = null;
          if (lcDataElements) {
            elementsData = lcDataElements?.children?.find(
              (item) => String(item._id) === String(lcData?.value)
            );
          }
          return (
            <TableCell
              align='center'
              key={`structure-${structure._id}-lc-${lc._id}-index-${index}`}
              backgroundColor={structure?.primaryColor}
              color={structure?.secondaryColor}
              className={[
                'min-w-200px w-full text-ellipsis relative border-l border-muted',
                lcData?.value ? '' : 'bg-lines'
              ].join(' ')}
              style={{
                backgroundColor: structure?.primaryColor,
                color: structure?.secondaryColor
              }}
              children={
                <>
                  <Typography className='text-ellipsis text-sm'>
                    {elementsData?.name || lcData?.value}
                  </Typography>
                  {/* <Chip label={`v${lc.version || '1'}`} size='small' color='primary' className='font-bold absolute top-2 right-2'/> */}
                </>
              }
            />
          );
        })}
      </TableRow>
    </>
  );
};

const CurriculumElementsRows = ({
  lcs = [],
  width = 'min-w-120px max-w-120px',
  currentCurriculum,
  classUlInfo
}) => {
  const lcsElements = {};
  lcs.forEach((lc) => {
    lcsElements[lc.lcId] = currentCurriculum.elements;
  });
  return (
    <>
      <RenderCurriculum
        elements={lcsElements}
        structure={currentCurriculum.elementsStructure}
        lcs={lcs || []}
        width={width}
      />
      {classUlInfo ? (
        <TableRow className=' sticky bottom-0 z-10'>
          <TableCell
            align='center'
            className={[
              'font-bold sticky bottom-1px left-0px z-12 text-primary-foreground bg-primary',
              width
            ].join(' ')}
            children='Version'
          >
            <Typography variant='inherit' children='Version' size='small' />
            <Typography variant='inherit' children='Class' size='small' className='text-lg' />
            <Typography
              variant='inherit'
              children='Unit of Learning'
              size='small'
              className='font-bold text-sm'
            />
          </TableCell>
          {lcs?.map((lc, index) => {
            const clss = lc?.classes?.[0];
            const ul = lc?.developmentalRubrics?.[0];
            return (
              <TableCell
                align='center'
                key={`lc-elements-version-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                  lc.classId || 'main'
                }-index-${index}`}
                className={[
                  'border-l border-muted min-w-200px w-full text-ellipsis text-primary-foreground bg-primary text-foreground-primary'
                ].join(' ')}
              >
                <Typography children={`V${lc.version || 1}`} size='small' className='font-bold text-sm' />
                <Typography
                  variant='inherit'
                  children={clss?.code || 'MAIN'}
                  size='small'
                  className='text-lg'
                />
                {ul ? (
                  <TextEllipsis variant='inherit' size='small' className='font-bold text-sm'>
                    {ul?.startDate && ul?.endDate && (
                      <TextStatusUnitOfLearning startDate={ul?.startDate} endDate={ul?.endDate} />
                    )}
                    <span className='font-bold text-sm pl-1'>{ul?.name || ''}</span>
                  </TextEllipsis>
                ) : (
                  <span className='font-bold text-sm'>-</span>
                )}
              </TableCell>
            );
          })}
        </TableRow>
      ) : (
        <TableRow className='sticky bottom-0 z-10'>
          <TableCell
            align='center'
            className={[
              'font-bold sticky bottom-1px left-0px z-11 text-primary-foreground bg-primary',
              width
            ].join(' ')}
            children='Version'
          />
          {lcs?.map((lc, index) => {
            return (
              <TableCell
                align='center'
                key={`lc-elements-version-lc-${lc._id}-index-${index}`}
                className={[
                  'border-l border-muted min-w-200px w-full text-ellipsis text-primary-foreground bg-primary'
                ].join(' ')}
                children={
                  <Typography
                    children={`V${lc.version || 1}${lc.ulId === '' ? ' (main)' : ''}`}
                    size='small'
                    className='font-bold text-sm'
                  />
                }
              />
            );
          })}
        </TableRow>
      )}
    </>
  );
};

export default CurriculumElementsRows;
